import firebase from 'firebase/app';

export async function processSelectedPeople(selected, location) {
   let people = [];
   for (const [key, value] of Object.entries(selected)) {
      if (value.type === 'location') {
         const coPeople = await firebase
            .firestore()
            .doc(`company/${location.cid}/indexes/people`)
            .get();
         if (coPeople.exists) {
            Object.entries(coPeople.data()).forEach(([personKey, personValue]) => {
               if (personValue.lid === value.id) {
                  people.push({
                     uid: personKey,
                     name: `${personValue.name.firstName} ${personValue.name.lastName}`,
                     type: 'user',
                  });
               }
            });
         }
      } else if (value.type === 'group') {
         const groupsResponse = await firebase
            .firestore()
            .doc(`location/${location.lid}/groups/${value.id}`)
            .get();
         if (groupsResponse.exists) {
            const groupData = groupsResponse.data();
            if (groupData.members) {
               console.log(groupData.members, groupsResponse.id, 'group members');
               Object.entries(groupData.members).forEach(([memberKey, memberValue]) => {
                  if (!people.some((person) => person.uid === memberKey)) {
                     people.push({
                        uid: memberKey,
                        name: `${memberValue.name.firstName} ${memberValue.name.lastName}`,
                        type: 'user',
                     });
                  }
               });
            }
         }
      } else {
         if (!people.some((person) => person.uid === value.id)) {
            people.push({ ...value, uid: value.id });
         }
      }
   }
   people.sort((a, b) => {
      const nameCompare = a.name.localeCompare(b.name);
      if (nameCompare !== 0) return nameCompare;
      return a.uid.localeCompare(b.uid);
   });
   console.log(people, 'processed people');
   return people;
}
